import { gql } from 'apollo-angular';

export const EMAIL_NOTIFICATION_PREFERENCE_QUERY = gql`
  query GetEmailNotificationsPreferences {
    EmailNotifications {
      data {
        category
        notification
      }
      isSuccess
      message
      errorCode
    }
  }
`;
